import * as Api from '../../../api/Api';
import { useEffect, useState, useContext } from 'react';
import { useGetToken } from '../../../Hooks/CustomHooks';
import { useQuery } from 'react-query';
import { Loading } from '../../../Components/Loading/Loading';
import { FeedbackContext } from "../../../Components/Context/FeedbackContext";
import { Modal } from 'react-bootstrap-v5';
import * as KeyNames from '../../../api/KeyNames';
import * as Utilities from '../../../Components/Utils/Utils';
import { ErrorConnection } from "../../../Components/Error/Error";

export default function ActualizarCierreVentas({ cierreVentas, setSmShow }) {

    const token = useGetToken();

    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);

    const [updateCierre, setUpdateCierre] = useState(false);

    const [cierreVentaId, setCierreVentaId] = useState(cierreVentas.cierreVentaId);
    const [ventasValor, setVentasValor] = useState(cierreVentas.ventasValor);
    const [numeroTransacciones, setNumeroTransacciones] = useState(cierreVentas.numeroTransacciones);


    let { data, isLoading, isError, error } = useQuery([KeyNames.SessionRespuesta,
    {
        cierreVentaId: cierreVentaId,
        ventasValor: ventasValor,
        numeroTransacciones: numeroTransacciones,
        token: token
    }],
        async () => await Api.ActualizarCierreVentas(
            {
                cierreVentaId: cierreVentaId,
                ventasValor: ventasValor,
                numeroTransacciones: numeroTransacciones,
                token: token
            }
        ),
        {
            enabled: Boolean(updateCierre)
        });


    useEffect(() => {
        if (data) {
            if (!data.success)
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
            else {
                setUpdateCierre(false);
                setSmShow(true);
            }
        }
    }, [data]);


    if (isLoading) return (<Loading />)
    if (isError) return (<ErrorConnection error={error} />)

    return (
        <>
            <Modal show={true} onHide={() => setSmShow(false)} className=''>
                <Modal.Header className='modal-header'>
                    <Modal.Title className='fw-bolder'>Actualizar Cierre de Venta
                    </Modal.Title>
                    <button type="button" onClick={() => setSmShow(false)} className="btn btn-icon btn-sm btn-active-icon-primary">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="black"></rect>
                            <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black"></rect>
                        </svg>
                    </button>
                </Modal.Header>
                <Modal.Body className='modal-body mx-5 mx-xl-10 my-7'>

                    <div className="fv-row mb-7 fv-plugins-icon-container">
                        <label className='fw-bold fs-6 mb-2'>Monto de Venta</label>
                        <input className='form-control form-control-solid mb-3 mb-lg-0' type="number" value={ventasValor} onChange={(e) => setVentasValor(e.target.value)} />

                    </div>
                    <div className="fv-row mb-7 fv-plugins-icon-container">
                        <label className='fw-bold fs-6 mb-2'>N. Transacciones</label>
                        <input className='form-control form-control-solid mb-3 mb-lg-0' type="number" value={numeroTransacciones} onChange={(e) => setNumeroTransacciones(e.target.value)} />
                    </div>

                </Modal.Body>
                <Modal.Footer className='text-center'>
                    <button className="btn btn-light me-3" onClick={() => setSmShow(false)}>
                        Cerrar
                    </button>
                    <button className="btn btn-primary" onClick={() => setUpdateCierre(true)}>
                        Actualizar
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}